import React, { useState, useEffect, act } from "react";
import { Nav, Image } from "react-bootstrap";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import "../css/Sidebar.css";
import "bootstrap/dist/css/bootstrap.min.css";
import userManagement from "../assets/images/icons/user-management-white-icon.png";
import creditManagement from "../assets/images/icons/Credit-Management-Icon.png";
import urlShortening from "../assets/images/icons/url-shortening-icon.png";
import { jwtDecode } from "jwt-decode";
import logo from "../assets/images/logo.svg";
import apiKeyIcon from "../assets/images/icons/api-key.png";
import reportsIcon from "../assets/images/icons/reports-white.svg";
import creditManagementDark from "../assets/images/icons/Credit-Management-Icon-black.png";
import analytics from "../assets/images/icons/dashboard.png";
import analyticsDark from "../assets/images/icons/dashboardDark.png";
import urlShorteningDark from "../assets/images/icons/urlIcondark.png";
import userManagementDark from "../assets/images/icons/userManageDark.png";
import accountManagement from "../assets/images/icons/accountMange.png";
import accountManagementDark from "../assets/images/icons/accountManageDark.png";
import reportsIconDark from "../assets/images/icons/reports.svg";
import apiKeyIconDark from "../assets/images/icons/apiKeyDark.png";
import connectorsIcon from "../assets/images/icons/APIIntegration.png";

const Sidebar = ({ sidebarOpen }) => {
  const location = useLocation();
  const [activeMenu, setActiveMenu] = useState("");
  const [userRole, setUserRole] = useState("");
  const navigate = useNavigate();

  const menuMapping = {
    urlShortening: ["/urlShorten"],
    analytics: ["/analytics"],
    userManagement: ["/user-management"],
    creditManagement: ["/credit-management"],
    customDomain: ["/custom-domain"],
    apiKey: ["/api-key"],
    connectors: ["/connectors"],
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const decoded = jwtDecode(token);
        const role = decoded.roles[0];
        setUserRole(role);
      } catch (error) {
        console.error("Error decoding token:", error);
      }
    }
  }, []);

  useEffect(() => {
    const foundMenu = Object.keys(menuMapping).find((menu) =>
      menuMapping[menu].some((path) => location.pathname.startsWith(path))
    );
    setActiveMenu(foundMenu || "");
  }, [location.pathname]);

  const handleMenuClick = (menu) => {
    setActiveMenu((prevMenu) => (prevMenu === menu ? "" : menu));
  };

  const isActive = location.pathname === "/help";

  const allMenus = {
    SUPERADMIN: [
      {
        to: "/dashboard",
        label: "Dashboard",
        defaultIcon: analytics,
        activeIcon: analyticsDark,
      },
      {
        to: "/super-admin-users",
        label: "Super Admin Users",
        defaultIcon: userManagement,
        activeIcon: userManagementDark,
      },
      {
        to: "/account-management",
        label: "Account Management",
        defaultIcon: accountManagement,
        activeIcon: accountManagementDark,
      },
      {
        to: "/credit-requests",
        label: "View Requests",
        defaultIcon: userManagement,
        activeIcon: userManagementDark,
      },
      {
        to: "/reports",
        label: "Reports",
        defaultIcon: reportsIcon,
        activeIcon: reportsIconDark,
      },
    ],
    ADMIN: [
      {
        to: "/analytics",
        label: "Analytics",
        defaultIcon: analytics,
        activeIcon: analyticsDark,
      },
      {
        to: "/urlShorten",
        label: "URL Shortening",
        defaultIcon: urlShortening,
        activeIcon: urlShorteningDark,
      },
      {
        to: "/user-management",
        label: "User Management",
        defaultIcon: userManagement,
        activeIcon: userManagementDark,
      },
      {
        to: "/credit-management",
        label: "Credit Management",
        defaultIcon: creditManagement,
        activeIcon: creditManagementDark,
      },
      {
        to: "/account-management",
        label: "Account Management",
        defaultIcon: accountManagement,
        activeIcon: accountManagementDark,
      },
      {
        to: "/custom-domain",
        label: "Custom Domain",
        defaultIcon: userManagement,
        activeIcon: userManagementDark,
      },
      {
        to: "/reports",
        label: "Reports",
        defaultIcon: reportsIcon,
        activeIcon: reportsIconDark,
      },
      {
        to: "/api-key",
        label: "API Key",
        defaultIcon: apiKeyIcon,
        activeIcon: apiKeyIconDark,
      },
      {
        to: "/connectors",
        label: "Connectors",
        defaultIcon: connectorsIcon,
        activeIcon: connectorsIcon,
      },
    ],
    USER: [
      {
        to: "/analytics",
        label: "Analytics",
        defaultIcon: analytics,
        activeIcon: analyticsDark,
      },
      {
        to: "/urlShorten",
        label: "URL Shortening",
        defaultIcon: urlShortening,
        activeIcon: urlShorteningDark,
      },
    ],
    CLIENT: [
      {
        to: "/analytics",
        label: "Analytics",
        defaultIcon: analytics,
        activeIcon: analyticsDark,
      },
      {
        to: "/reports",
        label: "Reports",
        defaultIcon: reportsIcon,
        activeIcon: reportsIconDark,
      },
    ],
  };

  const currentPath = location.pathname;

  return (
    <div className={`sidebar ${sidebarOpen ? "open" : ""}`}>
      <div
        className="nav-logo d-flex align-items-center justify-content-center"
        style={{
          position: "fixed",
          height: "70px",
          textAlign: "center",
          width: "220px",
        }}
      >
        <h2 className="ls-plus-0 lh-100 fw-500 fs-18 m-0 text-white GeneralSansMedium">
          <Image style={{cursor:'pointer'}} src={logo} width="150" onClick={() => navigate("/analytics")}/>
        </h2>
      </div>

      <div className="menu-scroll" style={{ marginTop: "70px" }}>
        <Nav className="flex-column mt-2">
          {(allMenus[userRole] || []).map((item, index) => {
            const isActive = currentPath === item.to;

            return (
              <Nav.Link
                key={index}
                as={NavLink}
                to={item.to}
                className="ls-plus-0 lh-100 fw-500 fs-14"
              >
                <Image
                  className="me-2 align-middle"
                  style={{ width: "20px" }}
                  src={isActive ? item.activeIcon : item.defaultIcon}
                  alt={item.label}
                />
                {item.label}
              </Nav.Link>
            );
          })}
        </Nav>
      </div>

      <div className="bottom-fixed-link">
        <Nav className="flex-column mt-2">
          <Nav.Link
            as={NavLink}
            to="/help"
            className="ls-plus-0 lh-100 fw-500 fs-14"
          >
            <Image
              className="me-2 align-middle"
              style={{ width: "20px" }}
              src={isActive ? accountManagementDark : accountManagement}
            />
            Help Center
          </Nav.Link>
        </Nav>
      </div>
    </div>
  );
};

export default Sidebar;
